<script lang="ts">
  export let steps: Array<{ id: string; label: string }> = [];
  export let currentStep: string;

  function getStepState(stepId: string): 'completed' | 'current' | 'future' {
    const currentIndex = steps.findIndex((s) => s.id === currentStep);
    const stepIndex = steps.findIndex((s) => s.id === stepId);
    if (stepIndex < currentIndex) return 'completed';
    if (stepIndex === currentIndex) return 'current';
    return 'future';
  }
</script>

<nav class="stepper" aria-label="Progresso das etapas">
  <ol class="stepper__list">
    {#each steps as step, idx (step.id)}
      {@const state = getStepState(step.id)}
      <li class="stepper__item stepper__item--{state}">
        <span class="stepper__indicator">{idx + 1}</span>
        <span class="stepper__label">{step.label}</span>
        {#if idx < steps.length - 1}
          <span class="stepper__connector" aria-hidden="true"></span>
        {/if}
      </li>
    {/each}
  </ol>
</nav>

<style>
  .stepper {
    width: 100%;
  }

  .stepper__list {
    display: flex;
    align-items: center;
    list-style: none;
    margin: 0;
    padding: 0;
    gap: 0;
  }

  .stepper__item {
    display: flex;
    align-items: center;
    gap: var(--ptt-space-2);
    flex: 1;
    min-width: 0;
  }

  .stepper__indicator {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    font-size: 0.75rem;
    font-weight: 700;
    flex-shrink: 0;
    transition: background 0.15s ease, color 0.15s ease;
  }

  .stepper__item--completed .stepper__indicator {
    background: var(--ptt-purple-100);
    color: var(--ptt-white);
  }

  .stepper__item--current .stepper__indicator {
    background: var(--ptt-yellow-100);
    color: var(--ptt-black);
  }

  .stepper__item--future .stepper__indicator {
    background: var(--ptt-gray-20);
    color: var(--ptt-gray-100);
  }

  .stepper__label {
    font-size: 0.875rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .stepper__item--completed .stepper__label {
    color: var(--ptt-purple-100);
  }

  .stepper__item--current .stepper__label {
    color: var(--ptt-gray-300);
    font-weight: 700;
  }

  .stepper__item--future .stepper__label {
    color: var(--ptt-gray-100);
  }

  .stepper__connector {
    flex: 1;
    height: 2px;
    background: var(--ptt-gray-20);
    margin: 0 var(--ptt-space-2);
    flex-shrink: 0;
    min-width: var(--ptt-space-3);
  }
</style>
